import { PictogramPlaceholderImages40 } from '@cian/ui-kit-design-tokens/pictograms';
import classNames from 'clsx';
import * as React from 'react';

import * as styles from './styles.css';
import { IImageFile } from '../../types/imageFile';
import { useImageOrientation } from '../ChatImage/hooks';
import { ChatImageLoader } from '../ChatImageLoader';

interface IChatImageProps {
  image: {
    src: string;
    width: number;
    height: number;
  };
  isLoading: boolean;
  isError: boolean;
  withCancel?: boolean;
  withReload?: boolean;
  onCancel(): void;
  onReload?(): void;
  isGalleryItem?: boolean;
}

export const ChatImageDraft: React.FC<IChatImageProps> = ({
  image,
  isLoading,
  isError,
  withCancel,
  withReload,
  onCancel,
  onReload,
  isGalleryItem,
}) => {
  const orientation = useImageOrientation(image as unknown as IImageFile);

  return (
    <div
      data-testid="chat_image_draft"
      data-name="ChatImageDraft"
      className={classNames(styles['container'], styles[orientation], isGalleryItem && styles['gallery_item'])}
    >
      <span className={styles['loader']} data-testid="loader" data-name="ChatImageDraft_loader">
        <ChatImageLoader
          isLoading={isLoading}
          withCancel={withCancel}
          withReload={withReload}
          onCancel={onCancel}
          onReload={onReload}
        />
      </span>
      {isError && (
        <div className={styles['error']} data-testid="error">
          <PictogramPlaceholderImages40 color="current_color" />
        </div>
      )}
      <img className={styles['image']} src={image.src} alt="Фото" />
    </div>
  );
};
